import { apiClient } from './client'
import type { Me } from './types'

/**
 * Phase 4: returns the signed-in User's row, JIT-provisioning on first call. Replaces the
 * stub /auth/login endpoint — login now happens via OIDC redirect handled by react-oidc-context.
 */
export const fetchMe = async (): Promise<Me> => {
  const response = await apiClient.get<Me>('/api/v1/auth/me')
  return response.data
}
